export default {
  nav: {
    home: 'Home',
    articles: 'Articles',
    tech: 'Tech',
    software: 'Software',
    tutorial: 'Tutorials',
    resource: 'Resources',
    news: 'News',
    tools: 'Tools',
    about: 'About',
    sponsor: 'Membership',
    copyright: 'Copyright'
  },
  header: {
    searchPlaceholder: 'Search articles...',
    searchMobilePlaceholder: 'Search articles & tools...',
    search: 'Search',
    navLabel: 'Navigation',
    drawerHint: 'Browse · tap to navigate',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    langZh: '中文',
    langEn: 'EN'
  },
  footer: {
    nav: 'Navigate',
    about: 'About',
    copyright: 'Copyright',
    feedback: 'Feedback',
    followUs: 'Follow us',
    channelsHint: 'Hover or tap QR to enlarge',
    allRights: 'All rights reserved',
    contactEmail: 'Contact',
    qrAlt: '{label} QR code',
    qrEnlarge: 'Enlarge {label} QR',
    close: 'Close',
    wechatScan: 'Scan with WeChat',
    filingHint: 'ICP for this domain: {label}',
    filingHintEmpty: 'ICP filing'
  },
  home: {
    readMore: 'Read more',
    noCarousel: 'No featured slides yet',
    noCarouselHint: 'Enable “Show on homepage carousel” in the admin article editor',
    latest: 'Latest',
    featured: 'Featured',
    views: 'views',
    softwareTitle: 'Software picks',
    softwareSubtitle: 'Handy apps for work, study, and development',
    tutorialTitle: 'Tutorials',
    tutorialSubtitle: 'From basics to real-world projects',
    resourceTitle: 'Resources',
    resourceSubtitle: 'Learning paths, open source, and book lists',
    techTitle: 'Tech articles',
    techSubtitle: 'Frontend, engineering, and performance',
    all: 'All',
    viewMore: 'See more',
    techCatTitle: '{cat} tech articles',
    emptyCategory: 'No posts in this category',
    seoIndex: 'All articles'
  },
  articles: {
    count: '{n} articles',
    searchPrefix: 'Search: {q}',
    all: 'All',
    tech: 'Tech',
    software: 'Software',
    tutorial: 'Tutorials',
    resource: 'Resources',
    news: 'News',
    titleAll: 'All articles',
    titleTech: 'Tech articles',
    titleSoftware: 'Software picks',
    titleTutorial: 'Tutorials',
    titleResource: 'Resources',
    titleNews: 'News',
    subCategory: 'Subcategory',
    softwareCats: 'Software categories',
    tutorialCats: 'Tutorial categories',
    resourceCats: 'Resource categories',
    techCats: 'Tech categories',
    tags: 'Tags',
    empty: 'No matching articles',
    featured: 'Featured'
  },
  article: {
    home: 'Home',
    body: 'Article',
    back: 'Back',
    repostFrom: 'Reposted from: ',
    readMinutes: '~{n} min',
    readAbout: 'Length',
    views: 'views',
    copyLink: 'Copy link',
    loadingBody: 'Loading content…',
    thanks: 'Thanks for reading',
    moreType: 'More {type}',
    related: 'Related',
    loading: 'Loading article…',
    notFound: 'Article not found',
    backToList: 'Back to articles',
    translationFallback: 'No English translation yet — showing Chinese original',
    original: 'Original',
    repost: 'Repost',
    publishedAt: 'Published {date}',
    updatedAt: 'Updated {date}',
    publish: 'Published',
    update: 'Updated',
    copied: 'Link copied',
    copyFailed: 'Copy failed',
    uncategorized: 'Uncategorized',
    authorDefault: 'Author',
    recommend: 'Recommended',
    hotTags: 'Popular tags',
    thisArticle: 'This article',
    category: 'Category',
    authorBio: 'Writing about tech and sharing useful notes',
    updatedShort: '↑',
    list: 'Articles'
  },
  friendLinks: {
    title: 'Blogroll',
    subtitle: 'Sites we recommend'
  },
  share: {
    label: 'Share',
    copyTo: 'Copy link for {name}',
    preview: 'Card preview',
    collapse: 'Hide preview',
    copied: 'Copied',
    copyLink: 'Copy link',
    previewTip: 'This card style appears when the link is pasted in WeChat, QQ, and similar apps',
    wechat: 'WeChat',
    qq: 'QQ',
    weibo: 'Weibo'
  },
  lock: {
    login: 'Sign-in required',
    member: 'Members only',
    paid: 'Paid',
    public: 'Public',
    loginMsg: 'Sign in to read this section',
    memberMsg: 'Become a member to read this section',
    paidMsg: 'Unlock this section with {n} {name}',
    paidMsgPlain: 'Unlock this section with {name}',
    myPoints: 'My {name}: ',
    insufficient: '(need {n} more)',
    loginRead: 'Sign in to read',
    openMember: 'Become a member',
    unlock: 'Unlock · {n} {name}',
    getPoints: 'Get {name}',
    loginFirst: 'Sign in first'
  },
  tools: {
    badge: 'Online toolkit',
    heroTitle: 'Practical tools, ready to use',
    heroDesc: 'PDF, images, barcodes, webmaster, life, networking, and config conversion — processed locally in your browser, fast and private.',
    countTools: 'tools',
    countCats: 'categories',
    localPct: 'local',
    searchPlaceholder: 'Search tools, e.g. PDF merge, QR code…',
    frequent: 'Frequent tools',
    frequentHintLogin: 'Synced to your account by usage; pin to keep on top',
    frequentHintGuest: 'Stored on this device; sign in to sync across devices',
    clear: 'Clear',
    clearConfirm: 'Clear frequent tools history?',
    cleared: 'Cleared',
    pin: 'Pin',
    unpin: 'Unpin',
    removeFrequent: 'Remove',
    frequentEmpty: 'Tools you use will appear here for quick access',
    all: 'All',
    toolsInCat: '{n} tools',
    empty: 'No matching tools',
    notFound: 'Tool not found',
    backHub: 'Back to toolkit',
    allTools: 'All tools',
    loginRequired: 'Sign in to use',
    loginTip: 'This tool requires an account. After signing in, files are processed locally in your browser.',
    loginNow: 'Sign in',
    tip: 'Notice'
  },
  about: {
    browseArticles: 'Browse articles',
    contactMe: 'Contact',
    role: 'Frontend developer · technical writer',
    bio1: 'A frontend developer focused on web engineering and UX. This blog is where I share notes, ideas, software picks, and project experience.',
    bio2: 'I aim to explain complex topics clearly and share useful tools so every visit is worthwhile.',
    online: 'Creating online',
    focusEyebrow: 'FOCUS',
    focusTitle: 'What I work on',
    focusSub: 'Write to capture experience; share to connect with more developers',
    focusWrite: 'Technical writing',
    focusWriteDesc: 'Frontend practice, engineering, and performance — explained clearly.',
    focusTools: 'Tool recommendations',
    focusToolsDesc: 'Curated apps and utilities that speed up daily work and learning.',
    focusTutorial: 'Hands-on tutorials',
    focusTutorialDesc: 'Project-based guides from beginner to advanced.',
    contentEyebrow: 'CONTENT',
    contentTitle: 'What you will find',
    contentSub: 'Four pillars covering beginner to advanced learning paths',
    techDesc: 'Frontend, performance, and engineering practice',
    softwareDesc: 'Utilities, office, and developer productivity apps',
    tutorialDesc: 'Structured learning from basics to advanced',
    resourceDesc: 'Learning materials, open source, and books',
    statArticles: 'Articles',
    statTech: 'Tech',
    statSoftware: 'Software',
    statTutorialResource: 'Tutorials & resources',
    techGroupFront: 'Frameworks',
    techGroupLang: 'Languages & styles',
    techGroupEng: 'Engineering',
    techGroupOther: 'Other',
    tagEng: 'Engineering',
    tagUx: 'UX',
    articleCount: '{n} articles',
    stackTitle: 'Stack',
    stackSub: 'Tools and frameworks used in daily work and writing',
    ctaTitle: 'Let’s talk',
    ctaDesc: 'Email is welcome for technical questions, collaboration, or content ideas. Thanks for supporting the site.',
    sponsorSupport: 'Support the site'
  },
  sponsor: {
    badge: 'Membership',
    title: 'Support {name} and unlock more content',
    desc: 'Your support helps keep tutorials, software picks, and tech articles coming. Choose how to start or renew.',
    memberUntil: 'Membership active until',
    renewNote: 'Renewals extend from the current expiry date',
    plansRenew: 'Renewal plans',
    plansBuy: 'Membership plans',
    plansDirectTip: 'Pick a plan and pay — membership activates automatically after payment',
    plansExternalTip: 'Buy on the card platform, then return here to redeem a CDK',
    plansIntroTip: 'Plan overview — activate with a redeem code after purchase',
    originalPrice: 'Was ¥{price}',
    unitPrice: 'About {unit}',
    renew: 'Renew',
    sponsorNow: 'Sponsor now',
    goBuy: 'Buy now',
    onlineBuy: 'Buy membership online',
    empty: 'Membership purchase is not available yet. Please contact the admin.',
    faqTitle: 'FAQ'
  },
  profile: {
    member: 'Member',
    normalUser: 'Regular user',
    joinedAt: 'Joined {date}',
    memberUntil: 'Member until {date}',
    changeAvatar: 'Change avatar',
    admin: 'Admin',
    renew: 'Renew',
    openSponsor: 'Become a member',
    history: 'History',
    orders: 'Orders',
    unlocked: 'Unlocked',
    sideLabel: 'Account',
    navAria: 'Profile navigation',
    tabInfo: 'Profile',
    tabInfoShort: 'Profile',
    tabSecurity: 'Security',
    tabSecurityShort: 'Security',
    tabHistory: 'History',
    tabHistoryShort: 'History',
    tabPoints: 'Points',
    tabPointsShort: 'Points',
    tabMember: 'Membership',
    tabMemberShort: 'Member',
    tabOrders: 'Orders',
    tabOrdersShort: 'Orders',
    guestTitle: 'Sign in to manage your account',
    guestDesc: 'Sync history, check-ins, membership, and orders',
    loginNow: 'Sign in'
  },
  copyright: {
    backHome: 'Back to home',
    title: 'Copyright notice',
    desc: 'Welcome to “{name}”. Please read the terms below. By using this site you agree to this notice.',
    updated: 'Last updated: Mar 10, 2026',
    effective: 'Effective: Jan 1, 2026',
    toc: 'Contents',
    contactPrefix: 'Questions about this notice? Email',
    contactSuffix: 'and we will reply within a reasonable time.',
    enNotice: 'The English version is for reference only. If it conflicts with the Chinese text, the Chinese version prevails.'
  },
  redirect: {
    back: 'Go back',
    leaving: 'You are leaving this site',
    invalid: 'Invalid link',
    leavingDesc: 'You are about to open a third-party site. Please confirm the destination first.',
    invalidDesc: 'This link could not be parsed. Check that the address is correct.',
    targetSite: 'Destination',
    copy: 'Copy',
    copied: 'Copied',
    linkName: 'Link title',
    fromArticle: 'From article',
    safety: 'Safety tips',
    tip1: 'Third-party content, privacy, and security are the responsibility of that site.',
    tip2: 'Do not enter passwords or payment details on unfamiliar pages.',
    tip3: 'If a page looks suspicious, close it and return here.',
    cancel: 'Cancel',
    confirm: 'Continue',
    countdown: 'After you confirm, the link opens in a new tab; this page stays open',
    invalidReason: 'Possible causes: bad URL format, unsupported protocol, or missing redirect parameter.',
    backHome: 'Back to home',
    footerTip: '{name} shows this warning before external links to help keep browsing safer'
  },
  common: {
    langSwitched: 'Language updated',
    tip: 'Notice'
  },
  auth: {
    login: 'Sign in',
    logout: 'Sign out',
    loggedOut: 'Signed out',
    register: 'Sign up',
    createAccount: 'Create account',
    welcomeBack: 'Welcome back',
    joinUs: 'Join us',
    forgotTitle: 'Reset password',
    welcomeDesc: 'Sign in to continue reading',
    registerDesc: 'Create an account to unlock more',
    qrDesc: 'Scan with WeChat for a quick, secure sign-in',
    forgotDesc1: 'Verify your registered email to reset the password',
    forgotDesc2: 'Set a new password, then sign in again',
    featCollect: 'Save articles you like',
    featHistory: 'Sync reading history',
    featPersonal: 'A more personal reading experience',
    featEmail: 'Email verification keeps the account safer',
    featCode: 'Codes expire in 10 minutes',
    featReset: 'Sign in right after a reset',
    passwordLogin: 'Password',
    qrLogin: 'Mini-program QR',
    account: 'Account',
    accountPh: 'Username or email',
    password: 'Password',
    passwordPh: 'Enter password',
    forgot: 'Forgot password?',
    noAccount: 'No account yet?',
    registerNow: 'Create one',
    hasAccount: 'Already have an account?',
    loginNow: 'Sign in',
    backLogin: 'Back to sign in',
    username: 'Username',
    usernamePh: 'More than 5 characters',
    email: 'Email',
    emailCode: 'Email code',
    codePh: '6-digit code',
    getCode: 'Get code',
    resendIn: 'Resend in {n}s',
    resend: 'Resend',
    passwordRule: 'More than 8 characters',
    confirmPassword: 'Confirm password',
    confirmPh: 'Enter password again',
    forgotHint1: 'Enter your registered email to get a code',
    forgotHint2: 'Set a new password',
    registeredEmail: 'Registered email',
    registeredEmailPh: 'The email you used to register',
    sendCode: 'Send code',
    code: 'Code',
    newPassword: 'New password',
    newPasswordPh: 'At least 6 characters',
    qrAlt: 'Scan to sign in',
    qrLoading: 'Loading QR…',
    qrExpired: 'Expired — tap to refresh',
    qrRefresh: 'Refresh QR',
    qrPending: 'Scan with WeChat, open the mini program, then confirm',
    qrExpiredHint: 'QR expired. Please refresh',
    qrCancelled: 'Cancelled. Refresh to try again',
    qrError: 'QR failed to load',
    rememberPassword: 'Remembered it?',
    resetPassword: 'Reset password',
    confirmNewPassword: 'Confirm new password',
    confirmNewPh: 'Enter the new password again'
  },
  user: {
    menu: 'Account menu',
    member: 'Member',
    normal: 'Regular user',
    expireUntil: 'Active until {date}',
    openHint: 'Become a member to unlock more content',
    checkin: 'Check in',
    checkinDaily: 'Daily check-in',
    checkedIn: 'Done',
    checkedInToday: 'Checked in today',
    checkinReward: 'Earn +{n} {name}',
    profile: 'Profile',
    myPoints: 'Points',
    history: 'History',
    recent: 'Recently viewed',
    viewAll: 'See all',
    noHistory: 'No reading history yet',
    justNow: 'Just now',
    minutesAgo: '{n} min ago',
    hoursAgo: '{n} h ago',
    streak: '{n}-day streak'
  }
}
